export const imgPopupSrcHandler = () => {
    $('.wp-block-image').on('click', function () {
		$(this).toggleClass('active');
		$('body').toggleClass('noscroll');
		const imgRef = $(this).find("img");
		const imgSrcString = imgRef.attr('srcset');
		if(!imgSrcString) {
			const prev = imgRef.attr("data-prev-src");
			const current = imgRef.attr("src"); 
			if(prev){
				imgRef.attr("src", prev); 
				imgRef.attr("data-prev-src", current);
			}
			return;
		};
		const srcObjArr = [];
		imgSrcString.split(',').map(item => {
			let str = item.split(" "); 
			if(!str[0]) str.shift();
			let corrWidth = str[1].split("").splice(0, str[1].length-1).join("");
			const obj = { width: Number(corrWidth), value: str[0]}
			srcObjArr.push(obj);
		});
		srcObjArr.sort((a,b) => {return a.width - b.width;});
		const highResImg = srcObjArr[srcObjArr.length-1].value;
		let prevSrc = imgRef.attr('src');
		imgRef.attr("data-prev-src", prevSrc);
		imgRef.attr("src", highResImg);
		imgRef.attr("srcset", "");
	});
	$('.wp-block-video').on('click', function () {
		$(this).toggleClass('active');
	});
}